<template>
  <el-form ref="form" :model="form">
    <el-row type="flex" class="gj-picker">
      <div class="gj-picker__editor">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="广告活动" name="adActivity">
             <div class="gj-picker__editor--body">
            <gj-table
                 name="ad-active"
                :index="false"
                :adapt-height="false"
                :height="440"
                :data="tableData0"
                border="inner"
                :loading="loading0"
                :columns="columns0"
                :show-overflow="false"
                :pagination="pagination0"
                :pagination-option="{small: true, background: false, layout: 'total, prev, pager, next, sizes'}"
                @sort-change="sortChange"
                @page-change="getStaticData"
            >
              <template v-slot:header:op>
                <gj-button type="text"  @click="addAllItem()">全部添加</gj-button>
              </template>
              <template v-slot:campaignName="{ row }">
                <div>
                    <gj-tooltip
                      style="color:#1F6EEF;"
                        :text-line="2"
                        :content="row.campaignName">
                      {{row.campaignName | defaultShow}}
                    </gj-tooltip>
                </div>
                 <!-- <p style="color:#1F6EEF; margin: 0;">{{row.campaignName | defaultShow}}</p> -->
                <el-tag size="mini" type="success" v-if="row.adsStatus === 1">活跃</el-tag>
                <gj-popover v-else trigger="hover">
                  <template slot="reference">
                    <el-tag size="mini" type="danger"
                      >不活跃
                      <i class="el-icon-arrow-down"></i>
                    </el-tag>
                  </template>
                  <div class="ad-status">
                    <span>广告活动</span>
                    <span
                      :style="{
                        color: row.campaignState === 0 ? '#333333' : '#F5222D',
                      }"
                      >{{ row.campaignState === 0 ? '启动中' : '暂停中' }}</span
                    >
                  </div>
                  <!-- <div class="ad-status">
                    <span>广告组</span>
                    <span
                      :style="{
                        color: row.groupState === 0 ? '#333333' : '#F5222D',
                      }"
                      >{{ row.groupState === 0 ? '启动中' : '暂停中' }}</span
                    >
                  </div>
                  <div class="ad-status" v-if="row.state !== null">
                    <span>投放</span>
                    <span
                      :style="{ color: row.state === 0 ? '#333333' : '#F5222D' }"
                      >{{ row.state === 0 ? '启动中' : '暂停中' }}</span
                    >
                  </div> -->
                </gj-popover>
              </template>
              <template v-slot:sameRule="{row}">
                <div v-if="row.sameRule && row.sameRule.length > 0">
                  <gj-popover trigger="click" placement="bottom" width="1000">
                    <template>
                        <gj-table
                            :columns="ruleColumns"
                            ref="gjTable"
                            :index="false"
                            :adapt-height="false"
                            :height="240"
                            name="maxNumTable"
                            :data="row.sameRule"
                            :show-overflow="false"
                        >
                        <template v-slot:applyObjectName="{row}">
                          <div>{{optionMap[row.applyObjectAdsType] | defaultShow}}</div>
                          <div style="color: #1F6EEF">{{row.applyObjectName}}</div>
                        </template>
                        <template v-slot:executeObjectAdsType="{row}">
                          {{optionMap[row.templateDetailVO.expressionVO.executeObjectAdsType] | defaultShow}}
                        </template>
                        <template v-slot:templateDetailVO="{row}">
                          {{getContent(row.templateDetailVO.expressionVO)}}
                        </template>
                        <template v-slot:templateName="{row}">
                          {{row.templateDetailVO.name}}
                        </template>
                        </gj-table>
                      <div slot="reference">
                        <span style="color: #F5222D; margin-right: 8px;">{{ row.sameRule.length}}</span>
                        <gj-button type="text" >查看</gj-button>
                      </div> 
                    </template>
                  </gj-popover>
                </div>
                <div v-else>0</div>
              </template>
              <template v-slot:op="{ index, row }">
                <template >
                  <gj-button
                      v-if="(row.exist === 0 && signTagList.indexOf(row.campaignId) == -1)"
                      size="mini"
                      type="primary"
                      style="padding: 5px 15px;"
                      @click="addItem(row)"
                  >添加</gj-button>
                   <gj-button
                      v-else
                      size="mini"
                      :disabled="true"
                      style="padding: 5px 15px;"
                  >已添加</gj-button>
              
                </template>
          
              </template>
            </gj-table>
          </div>

          </el-tab-pane>
          <el-tab-pane label="广告组" name="adGroup" v-if="isShowGroup !== false">
             <div class="gj-picker__editor--body">
            <gj-table
                name="ad-group"
                :index="false"
                :adapt-height="false"
                :height="440"
                :data="tableData1"
                border="inner"
                :loading="loading1"
                :columns="columns1"
                :show-overflow="false"
                :pagination="pagination1"
                :pagination-option="{small: true, background: false, layout: 'total, prev, pager, next, sizes'}"
                @sort-change="sortChange"
                @page-change="getStaticData"
            >
              <template v-slot:header:op>
                <gj-button type="text"  @click="addAllItem">全部添加</gj-button>
              </template>
                <template v-slot:campaignName="{ row }">
                  <gj-tooltip
                    style="color:#1F6EEF;"
                      :text-line="2"
                      :content="row.campaignName">
                    {{row.campaignName | defaultShow}}
                  </gj-tooltip>
                 <!-- <p style="color:#1F6EEF; margin: 0;">{{row.campaignName | defaultShow}}</p> -->
              </template>
              <template v-slot:groupName="{ row }">
              <div>
                  <gj-tooltip
                style="color:#1F6EEF;"
                  :text-line="2"
                  :content="row.groupName">
                {{row.groupName | defaultShow}}
              </gj-tooltip>
              </div>
                 <!-- <p style="color:#1F6EEF; margin: 0;">{{row.groupName | defaultShow}}</p> -->
                 <el-tag size="mini" type="success" v-if="row.adsStatus === 1">活跃</el-tag>
                <gj-popover v-else trigger="hover">
                  <template slot="reference">
                    <el-tag size="mini" type="danger"
                      >不活跃
                      <i class="el-icon-arrow-down"></i>
                    </el-tag>
                  </template>
                  <div class="ad-status">
                    <span>广告活动</span>
                    <span
                      :style="{
                        color: row.campaignState === 0 ? '#333333' : '#F5222D',
                      }"
                      >{{ row.campaignState === 0 ? '启动中' : '暂停中' }}</span
                    >
                  </div>
                  <div class="ad-status">
                    <span>广告组</span>
                    <span
                      :style="{
                        color: row.groupState === 0 ? '#333333' : '#F5222D',
                      }"
                      >{{ row.groupState === 0 ? '启动中' : '暂停中' }}</span
                    >
                  </div>
                  <!-- <div class="ad-status" v-if="row.state !== null">
                    <span>投放</span>
                    <span
                      :style="{ color: row.state === 0 ? '#333333' : '#F5222D' }"
                      >{{ row.state === 0 ? '启动中' : '暂停中' }}</span
                    >
                  </div> -->
                </gj-popover>
              </template>
              <template v-slot:sameRule="{row}">
                <div v-if="row.sameRule && row.sameRule.length > 0">
                  <gj-popover trigger="click" placement="bottom" width="1000">
                    <template>
                        <gj-table
                            :columns="ruleColumns"
                            ref="gjTable"
                            :index="false"
                            :adapt-height="false"
                            :height="240"
                            name="maxNumTable"
                            :data="row.sameRule"
                            :show-overflow="false"
                        >
                        <template v-slot:applyObjectName="{row}">
                          <div>{{optionMap[row.applyObjectAdsType] | defaultShow}}</div>
                          <div style="color: #1F6EEF">{{row.applyObjectName}}</div>
                        </template>
                        <template v-slot:executeObjectAdsType="{row}">
                          {{optionMap[row.templateDetailVO.expressionVO.executeObjectAdsType] | defaultShow}}
                        </template>
                        <template v-slot:templateDetailVO="{row}">
                          {{getContent(row.templateDetailVO.expressionVO)}}
                        </template>
                        <template v-slot:templateName="{row}">
                          {{row.templateDetailVO.name}}
                        </template>
                        </gj-table>
                      <div slot="reference">
                        <span style="color: #F5222D; margin-right: 8px;">{{ row.sameRule.length}}</span>
                        <gj-button type="text" >查看</gj-button>
                      </div> 
                    </template>
                  </gj-popover>
                </div>
                <div v-else>0</div>
              </template>
              <template v-slot:op="{ index, row }">
                <template >
                    <gj-button
                      v-if="(row.exist === 0 && signTagList.indexOf(row.groupId) == -1)"
                      size="mini"
                      type="primary"
                      style="padding: 5px 15px;"
                      @click="addItem(row)"
                  >添加</gj-button>
                   <gj-button
                      v-else
                      size="mini"
                      :disabled="true"
                      style="padding: 5px 15px;"
                  >已添加</gj-button>
                </template>
          
              </template>
            </gj-table>
          </div>

          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="gj-picker__table">
        <div class="gj-picker__table--title" style="font-size: 12px">
          已添加{{pagination2.total}}个
        </div>
        <gj-table
            ref="gjTable"
            name="seletion-apply"
            :index="false"
            :adapt-height="false"
            :height="480"
            :loading="loading2"
            :data="tableData2"
            :columns="columns2"
            :show-overflow="false"
            border="inner"
        >
          <template v-slot:header:op>
            <gj-button type="text"  @click="removeAllItem()">全部移除</gj-button>
          </template>
          <template v-slot:campaignName="{ row }">
            <gj-tooltip
                style="color:#1F6EEF;"
                  :text-line="2"
                  :content="row.campaignName">
                {{row.campaignName | defaultShow}}
              </gj-tooltip>
                 <!-- <el-tag size="mini" type="danger">{{ row.adsStatus === 1 ? '活跃' : '不活跃' }}</el-tag> -->
          </template>
          <template v-slot:activeName="{ row }">
           <div>
            <gj-tooltip
               style="color:#1F6EEF;"
                :text-line="2"
                :content="row.objectName">
              {{row.objectName | defaultShow}}
            </gj-tooltip>
           </div>
              <!-- <p style="color:#1F6EEF; margin: 0;">{{row.objectName | defaultShow}}</p> -->
              <el-tag size="mini" type="info">{{ optionMap[row.activeName] | defaultShow }}</el-tag>
          </template>
           <template v-slot:sameRule="{row}">
                <div v-if="row.sameRule && row.sameRule.length > 0">
                  <gj-popover trigger="click" placement="bottom" width="1000">
                    <template>
                        <gj-table
                            :columns="ruleColumns"
                            ref="gjTable"
                            :index="false"
                            :adapt-height="false"
                            :height="240"
                            name="maxNumTable"
                            :data="row.sameRule"
                            :show-overflow="false"
                        >
                        <template v-slot:applyObjectName="{row}">
                          <div>{{optionMap[row.applyObjectAdsType] | defaultShow}}</div>
                          <div style="color: #1F6EEF">{{row.applyObjectName}}</div>
                        </template>
                        <template v-slot:executeObjectAdsType="{row}">
                          {{optionMap[row.templateDetailVO.expressionVO.executeObjectAdsType] | defaultShow}}
                        </template>
                        <template v-slot:templateDetailVO="{row}">
                          {{getContent(row.templateDetailVO.expressionVO)}}
                        </template>
                        <template v-slot:templateName="{row}">
                          {{row.templateDetailVO.name}}
                        </template>
                        </gj-table>
                      <div slot="reference">
                        <span style="color: #F5222D; margin-right: 8px;">{{ row.sameRule.length}}</span>
                        <gj-button type="text" >查看</gj-button>
                      </div> 
                    </template>
                  </gj-popover>
                </div>
                <div v-else>0</div>
              </template>
          <template v-slot:op="{ index, row }">
            <gj-button type="text" @click="removeItem(index, row)">移除</gj-button>
          </template>
        </gj-table>
      </div>
    </el-row>
  </el-form>
</template>

<script>
  import {
    formMixin,
    isMeaningfulMixin,
    queryMixin,
    isMeaninglessMixin
  } from "@/minxins";
  import {
    defaultVal,
    isMeaningful,
    isMeaningless,
    unique
  } from "@/utils/common";
  import { getAutoRuleCampaignData, getAutoRuleGroupData, querySameRule } from "@/api/ad";
  import { mapGetters } from "vuex";
  import {optionMap, getRuleContent} from '../const'

  export default {
    name: "ad-apply-picker",
    mixins: [isMeaningfulMixin, formMixin, queryMixin, isMeaninglessMixin],
    props: {
      title: {
        required: true
      },
      templateId: {
        required: true
      },
      executeObjectAdsType: {
        type: String,
        default: ''
      },
      strategyType: {
        type: String,
        default: ''
      },
      isShowGroup:{
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    created() {
    
    },
    data() {
      return {
        optionMap,
        columns0: [
          { id: 'marketId', header: '站点', field: 'option:marketId', minWidth: '100px', options: () => this.marketOption},
          { id: "campaignName", header: "广告活动", field: "slot:campaignName", minWidth: "180px",sortable: true},
          { id: "sameRule", header: "相似规则", field: "slot:sameRule", minWidth: "60px"},
          { id: "op", header: "slot:op", field: "slot:op", width: "90px", fixed: 'right' }
        ],
        columns1: [
          { id: 'marketId', header: '站点', field: 'option:marketId', minWidth: '100px', options: () => this.marketOption},
          { id: "groupName", header: "广告组", field: "slot:groupName", minWidth: "100px", sortable: true},
          { id: "campaignName", header: "广告活动", field: "slot:campaignName", minWidth: "120px",sortable: true},
          { id: "sameRule", header: "相似规则", field: "slot:sameRule", minWidth: "60px"},
          { id: "op", header: "slot:op", field: "slot:op", width: "90px", fixed: 'right' }
        ],
        columns2: [
          { id: 'marketId', header: '站点', field: 'option:marketId', minWidth: '100px', options: () => this.marketOption},
          { id: "activeName", header: "应用对象", field: "slot:activeName", minWidth: "100px"},
          { id: "campaignName", header: "广告活动", field: "slot:campaignName", minWidth: "120px"},
          { id: "sameRule", header: "相似规则", field: "slot:sameRule", minWidth: "60px"},
          { id: "op", header: "slot:op", field: "slot:op", width: "90px",fixed: 'right' }
        ],
        ruleColumns: [
          {id: 'applyObjectName', header: '应用对象', field: 'slot:applyObjectName', minWidth: '100px'},
          {id: 'executeObjectAdsType', header: '优化对象', field: 'slot:executeObjectAdsType', minWidth: '100px', },
          {id: 'templateName', header: '模版名称', field: 'slot:templateName', minWidth: '100px'},
          {id: 'templateDetailVO', header: '规则', field: 'slot:templateDetailVO', minWidth: '200px',}
        ],
        isMeaningful: isMeaningful,
        activeName: 'adActivity',
        tableData0: [],
        tableData1: [],
        tableData2: [],
        loading0: false,
        loading1: false,
        loading2: false,
        pagination0: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        sort0: {
          order: 'descending',
          sort: ''
        },
        pagination1: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        sort1: {
          order: 'descending',
          sort: ''
        },
        pagination2: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        sort2: {
          order: 'descending',
          sort: ''
        },
        selectRemoveList:[],
        signTagList:[],    //标记已添加的数据
      };
    },
    watch: {
  
    },
    
    methods: {
      updateData() {
        if (this.activeName === 'adActivity') {
          //广告活动
          const params = {
            model: {
              marketId: this.form.marketId,
              // campaignIds: this.form.campaignIds,
              campaignName: this.form.adActivityStr,
              adsStatus: this.form.adsStatus,
              same: this.form.same,
              templateId: this.templateId,
            },
            sort: this.sort0.sort,
            order: this.sort0.order,
            current: this.pagination0.currentPage,
            size: this.pagination0.pageSize,
          };
          // 查询
          this.loading0 = true;
          getAutoRuleCampaignData(params)
            .then(data => {
              if (isMeaningful(data) && isMeaningful(data.records)) {
                this.pagination0 = this.updatePagination(data);
                this.tableData0 = this.signAddTagData(data.records, 'campaignId');
                this.queryRule(this.tableData0).then(data => {
                  this.tableData0 = data
                });
              } else {
                this.tableData0 = [];
              }
            })
            .complete(() => (this.loading0 = false));

        }else {
          //广告组
          const params = {
            model: {
              marketId: this.form.marketId,
              campaignIds: this.form.campaignIds,
              // groupIds: this.form.groupIds,
              groupName: this.form.adGroupStr,
              adsStatus: this.form.adsStatus,
              same: this.form.same,
              templateId: this.templateId,
            },
            sort: this.sort1.sort,
            order: this.sort1.order,
            current: this.pagination1.currentPage,
            size: this.pagination1.pageSize,
          };
          // 查询
          this.loading1 = true;
          getAutoRuleGroupData(params)
            .then(data => {
              if (isMeaningful(data) && isMeaningful(data.records)) {
                this.pagination1 = this.updatePagination(data);
                this.tableData1 = this.signAddTagData(data.records, 'groupId');
                this.queryRule(this.tableData1).then(data => {
                  this.tableData1 = data
                });
              } else {
                this.tableData1 = [];
              }
            })
            .complete(() => (this.loading1 = false));
        }
         
      },
      // 查询相似规则
      async queryRule(arr) {
        let dArr = [];
         if (this.activeName === 'adActivity') {
            const params = {
              marketId: arr[0].marketId,
              applyObjectAdsType: arr[0].applyObjectAdsType,
              applyObjectIds: arr.map(item => item.campaignId),
              executeObjectAdsType: this.executeObjectAdsType,
              strategyType: this.strategyType
            }
            await querySameRule(params).then(data => {
              if (data.length) {
                dArr = arr.map(item => {
                  item.sameRule = data.filter(el => item.campaignId === el.applyObjectId)
                  item.sameRule = item.sameRule.length ? item.sameRule[0].ruleDetails : item.sameRule;
                  return item;
                });
              } else {
                dArr = arr.map(item => {
                  item.sameRule = []
                  return item;
                });
              }
            })

         }else {
            const params = {
              marketId: arr[0].marketId,
              applyObjectAdsType: arr[0].applyObjectAdsType,
              applyObjectIds: arr.map(item => item.groupId),
              executeObjectAdsType: this.executeObjectAdsType,
              strategyType: this.strategyType
            }
            await querySameRule(params).then(data => {
              if (data.length) {
                dArr = arr.map(item => {
                  item.sameRule = data.filter(el => item.groupId === el.applyObjectId)
                  item.sameRule = item.sameRule.length ? item.sameRule[0].ruleDetails : item.sameRule;
                  return item;
                });
              } else {
                dArr = arr.map(item => {
                  item.sameRule = []
                  return item;
                });
              }
            })
         }
   
        return dArr;
      },
      //标记数据是否可以添加
      signAddTagData(data, key) {
        let list = data.map(item => {
           if (this.signTagList.indexOf(item[key]) > -1) {
             item.exist = 1;
           }
           return item;
        })
        return list;
      },
      handleClick(tab, event) {
        this.$emit('tabChange', this.activeName);
        this.updateData();
      },
      selectReset() {
        this.pagination0 = {
            currentPage: 1,
            pageSize: 20,
            total: 0
        }
        this.pagination1 = {
            currentPage: 1,
            pageSize: 20,
            total: 0
        }
        this.updateData();

      },
      getStaticData(data){
        this.updateData();
      },
      updatePagination(queryResponse) {
        return {
          currentPage: queryResponse.current,
          pageSize: queryResponse.size,
          total: queryResponse.total,
        };
      },
      //全部添加
      addAllItem() {
        var list = [];
        if (this.activeName === 'adActivity') {
          list = this.tableData0.map((item) => {
            if (item.exist === 0) {
                var info = {
                marketId: item.marketId,
                adsType: 'sp',
                campaignId: item.campaignId,
                applyObjectId: item.campaignId,
                applyObjectName: item.campaignName,
                applyObjectAdsType: item.applyObjectAdsType,
                campaignName: item.campaignName,
                activeName: this.activeName,
                objectName: item.campaignName,
                sameRule: item.sameRule,
                selectStr: item.campaignId + '-' + item.groupId,
              }
              return info;
            }
          })
        }else {
           list = this.tableData1.map((item) => {
             if (item.exist === 0) {
                  var info = {
                  marketId: item.marketId,
                  adsType: 'sp',
                  campaignId: item.campaignId,
                  applyObjectId: item.groupId,
                  applyObjectName: item.groupName,
                  applyObjectAdsType: item.applyObjectAdsType,
                  campaignName: item.campaignName,
                  activeName: this.activeName,
                  objectName: item.groupName,
                  sameRule: item.sameRule,
                  selectStr: item.campaignId + '-' + item.groupId,
                }
                return info;
             }
          })
        }
        var seList = [...this.tableData2];
        seList = list.concat(seList);
        //数组去重
        this.tableData2 = this.duplicationArray(seList, 'applyObjectId');
        this.pagination2.total = this.tableData2.length;
        this.form.tableData2 = this.tableData2;
        this.signTagList = this.tableData2.map(item =>item.applyObjectId);
      },
       //数组去重
      duplicationArray(arr, key) {
        let map = new Map();
        for (let item of arr) {
            if (isMeaningful(item)) {
              map.set(item[key], item);
            }
        }
        return [...map.values()];
      },
      //全部删除
      removeAllItem() {
          if (this.tableData2.length > 0) {
              this.tableData2 = [];
              this.pagination2.total = this.tableData2.length;
              this.form.tableData2 = this.tableData2;
              this.signTagList = this.tableData2.map(item =>item.applyObjectId);
          }
      },
      //单个添加
      addItem(row) {
        var info = {};
         if (this.activeName === 'adActivity') {
            info = {
              marketId: row.marketId,
              adsType: 'sp',
              campaignId: row.campaignId,
              applyObjectId: row.campaignId,
              applyObjectName: row.campaignName,
              applyObjectAdsType: row.applyObjectAdsType,
              campaignName: row.campaignName,
              activeName: this.activeName,
              objectName: row.campaignName,
              sameRule: row.sameRule,
            }
        }else {
            info = {
              marketId: row.marketId,
              adsType: 'sp',
              campaignId: row.campaignId,
              applyObjectId: row.groupId,
              applyObjectName: row.groupName,
              applyObjectAdsType: row.applyObjectAdsType,
              campaignName: row.campaignName,
              activeName: this.activeName,
              objectName: row.groupName,
              sameRule: row.sameRule,
            }
        }
        this.tableData2.unshift(info);
        this.tableData2 = this.duplicationArray(this.tableData2, 'applyObjectId');
        this.pagination2.total = this.tableData2.length;
        this.form.tableData2 = this.tableData2;
        this.signTagList = this.tableData2.map(item =>item.applyObjectId);

      },
      //单个删除
      removeItem(index, row) {
          this.tableData2.splice(index, 1);
          this.pagination2.total = this.tableData2.length;
          this.form.tableData2 = this.tableData2;
          this.signTagList = this.tableData2.map(item =>item.applyObjectId);
      },
      //规则
     getContent(item) {
      return getRuleContent(item);
    },
    sortChange({column, property, order}) {
      console.log('sort===',order, column.sortBy);
      if (this.activeName === 'adActivity') {
        if (order) {
          this.sort0.sort = (column.sortBy || property || '').replace(/(slot:)|(option(\(.*\))?:)/, '');
          this.sort0.order = `${order}ending`;
        } else {
          this.sort0.sort = null;
          this.sort0.order = 'descending';
        }
      }else {
        if (order) {
          this.sort1.sort = (column.sortBy || property || '').replace(/(slot:)|(option(\(.*\))?:)/, '');
          this.sort1.order = `${order}ending`;
        } else {
          this.sort1.sort = null;
          this.sort1.order = 'descending';
        }
      }
   
      this.updateData();
    },

    }
  };
</script>

<style lang="scss" scoped>
  @import "./ad-apply";


  .gj-picker__editor {
    height: auto;
    width: 50%;
    padding: 0;
  }
  //.gj-picker__table {
  //  width: calc(100% - 540px);
  //}
  .gj-picker__table {
    width: 50%;
  }
  /deep/ .el-input-group__append {
    border-radius: 0;
    border: none;
    padding: 0 14px;
  }
  /deep/ .el-pagination .btn-prev {
    padding-right: 3px;
  }
  /deep/ .el-pagination .btn-next {
    padding-left: 3px;
  }
  /deep/ .el-pagination__total {
    margin-right: 2px;
  }
  /deep/ .footer__pagination {
    margin-right: 0;
    padding: 7px 16px !important;
  }
  /deep/ .el-pagination {
    padding-right: 0;
  }
  /deep/ .el-pagination .el-select .el-input {
    width: 90px;
  }
  /deep/ .el-pagination__sizes .el-select {
    // top: -4px;
  }
  //修正本组件在el-form下样式差异
  /deep/ .footer__pagination {
    // height: 40px;
    // line-height: 40px;
    //border-bottom: 1px solid #d9d9d9;
    // padding: 0 !important;
  }
  /deep/ .el-pagination,
  .el-pagination--small {
    // height: 40px;
    // line-height: 40px;
    // padding: 0;
    .el-pager{
      display: flex;
      align-items: center;
    }
  }
  /deep/ .el-pagination--small span:not([class*="suffix"]) {
    vertical-align: middle;
  }
  /deep/ .el-pagination {
    li {
      vertical-align: middle;
    }
    button {
      vertical-align: middle;
    }
  }

  /deep/ .el-col-10 > a {
    color: #1F6EEF;
    text-decoration-line: none;
  }
  .disable {
    padding: 5px 15px;
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }
  /deep/.gj-picker__select--header{
    padding: 8px 10px;
    border-bottom: 1px solid #d9d9d9;
    height:auto;
    line-height: 1;
  }
  /deep/.gj-picker__table--title{
    font-size: 12px;
    line-height: 18px;
    padding: 5px 10px;
    border-bottom: 0;
  }
  /deep/.gj-picker{
    height: auto;
  }
    /deep/.el-tabs__header {
    margin-bottom: 0 !important;
    padding-left: 10px;
  }
  /deep/.el-tabs__item  {
    height: 28px;
    line-height: 28px;
  }
  /deep/.el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #fff;
  }
.ad-status {
  color: #333333;
  display: flex;
  justify-content: space-between;
}
.ad-status + .ad-status {
  margin-top: 8px;
}
</style>

